import React, { useContext, useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";
import { BsChevronDown } from 'react-icons/bs';
import { BsPerson } from 'react-icons/bs';
import { BsCash } from 'react-icons/bs';

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem('theme')


  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    const code = user?.referral_code ?? "";
    if (!code) return;
    navigator.clipboard.writeText(code);


    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user == null) {
    return null;
  }

  const referralText = `Hi Friends, Play empireludo Ludo and earn 10000 daily. Download Indian App empireludo
  बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
   दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा
  
    Empireludo पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
    100% भरोसेमंद प्लेटफार्म । 24 hours support https://empireludo.com/login/${user?.referral_code}
    
    Your ReferralCode is -${user?.referral_code}.`


  // language 


  const translations = {
    hi: {
      referral: 'आपकी रेफरल कमाई',
      referPerson: 'आमंत्रित किये दोस्त | ',
      referEarn: 'रेफरल कमाई  ',
      referCode: 'रेफरल कोड ',
    },
    en: {
      referral: 'Your Referral Earnings',
      referPerson: 'Referred Players',
      referEarn: 'Referral Earning',
      referCode: 'Referral Code',
    },
  };

  // change theme 

  const styles = {
    backgroundColor: theme === 'light' ? '#fff' : 'black',
    color: theme === 'light' ? 'black' : 'black',
  };
  const styles1 = {
    color: theme === 'light' ? 'black' : 'white',
  };


  return (
    <>
      {/* <Header user={user} /> */}
      <div style={styles}>
        <div
          className="leftContainer mb_space"
        >
         <section className="refer_page_new">

            {/* TOP CARD */}
            <div className="refer_stats_card">

              <div className="refer_title_box">
                <h2>Your Referral Earnings</h2>
                <div className="title_glow_line"></div>
              </div>

              <div className="refer_stats_grid">

                {/* USERS */}
                <div className="refer_stat_item">

                  <div className="stat_icon blue_bg">
                    👥
                  </div>

                  <div>
                    <h5>Referred Players</h5>

                    <h3>
                      {user?.referral_user?.length}
                    </h3>
                  </div>
                </div>

                {/* EARNING */}
                <div className="refer_stat_item">

                  <div className="stat_icon purple_bg">
                    💰
                  </div>

                  <div>
                    <h5>Referral Earning</h5>

                    <h3 className="green_text">
                      ₹ {user?.referral_earning}
                    </h3>
                  </div>
                </div>

              </div>
            </div>

            {/* REFERRAL CODE */}
            <div className="refer_code_card">

              <div className="refer_title_box">
                <h2>Referral Code</h2>
                <div className="title_glow_line"></div>
              </div>

              {/* CODE BOX */}
              <div className="referral_code_box">

                <div className="code_left">
                  <span className="code_label">
                    Your Code
                  </span>

                  <h3>
                    {user?.referral_code}
                  </h3>
                </div>

                <button
                  className="copy_btn_new"
                  onClick={(e) => copyCode(e)}
                >
                  Copy
                </button>
              </div>

              {/* OR */}
              <div className="or_divider">
                <span>OR SHARE</span>
              </div>

              {/* SOCIAL */}
              <div className="social_share_grid">

                {/* WHATSAPP */}
                <a
                  className="social_btn whatsapp_btn"
                  href={`whatsapp://send?text=Play On EmpireLudo https://empireludo.com/login/${user.referral_code}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BsWhatsapp />
                </a>

                {/* FACEBOOK */}
                {/* <a
                  className="social_btn facebook_btn"
                  href={`https://www.facebook.com/sharer/sharer.php?u=https://empireludo.com/login/${user?.referral_code}`}
                  target="_blank"
                >
                  <AiFillFacebook />
                </a> */}

                {/* TELEGRAM */}
                {/* <a
                  className="social_btn telegram_btn"
                  href={`https://telegram.me/share/url?url=https://empireludo.com/login/${user?.referral_code}`}
                  target="_blank"
                >
                  <FaTelegramPlane />
                </a> */}

                {/* COPY */}
                <CopyToClipboard text={referralText}>
                  <button
                    className="social_btn copy_social_btn"
                    onClick={(e) => copyLink(e)}
                  >
                    <FiCopy />
                  </button>
                </CopyToClipboard>

              </div>

              {/* BONUS CARD */}
              <div className="referral_bonus_boxs">

                

              </div>

            </div>
            </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
